import Login from "./pages/Login";
import Home from './pages/Home'
import NewVisit from './pages/Visits/newVisit'
import EditVisit from './pages/Visits/edit'
import VisitOptons from './pages/Visits/options'
import VisitDetail from './pages/VisitDetail'
import Visits from './pages/Visits'
import Report from './pages/Report'

const routes = [
  {
    path: "/",
    title: "Login",
    component: Login,
  },
  {
    path: "/home",
    title: "Home",
    component: Home,
  },
  {
    path: "/add-visit/:project",
    title: "NewVisit",
    component: NewVisit,
  },
  {
    path: "/edit-visit/:id",
    title: "EditVisit",
    component: EditVisit,
  },
  {
    path: "/add/visit/options",
    title: "VisitOptions",
    component: VisitOptons,
  },
  {
    path: "/visit-detail/:id",
    title: "VisitDetail",
    component: VisitDetail,
  },
  {
    path: "/visits",
    title: "Visits",
    component: Visits,
  },
  {
    path: "/report",
    title: "Report",
    component: Report,
  },
];
export default routes;

